<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title">
        <div class="flex justify-start align-center" >
          <div class="icon-box">
            <i class="iconfont icon-zizhutuiguang"></i>
          </div>
          <b>宣传信息</b>
        </div>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" label-width="80px" class="flex">
            <el-form-item label="关键词">
              <el-input v-model="search.keyword" clearable placeholder="请输入关键词搜索"></el-input>
            </el-form-item>
            <el-form-item label="提交时间">
                <el-date-picker
                  class="inp"
                  clearable
                  v-model="search.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="请选择"
                  end-placeholder="请选择">
                </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchFun">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
          <div class="search-btn reset" @click="reset">
            <i class="iconfont icon-huanxiang"></i>重置
          </div>
        </div>
        <div class="shensu" @click="add">
          <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i>
          上传宣传信息
        </div>
      </div>
      <div class="list ">
        <el-table
          border
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="title"
            width="450"
            label="信息内容">
          </el-table-column>
          <el-table-column
            prop="content"
            label="描述">
          </el-table-column>
          <el-table-column
            width="250"
            prop="create_time"
            label="上传时间">
          </el-table-column>
          <el-table-column
            width="200"
            label="状态">
            <template slot-scope="scope">
              {{scope.row.status == 2 ? '已采纳' : '未采纳'}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250">
            <template slot-scope="scope" class="flex">
              <div class="edit" @click="edit(scope.row)">编辑</div>
              <div class="del" @click="del(scope.row)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>

    <addXuanchuanDialog
      :dialogVisible="dialogVisible"
      :id="id"
      @handleClose="handleClose" />
  </div>
</template>
<script>
import {isYes} from "@/utils/const";
import addXuanchuanDialog from "@/views/home/dialog/addXuanchuanDialog";
import {del_promote, promote_lst} from "@/api";
export default {
  name: "publicizeList",
  data() {
    return {
      isYes:isYes,
      dialogVisible: false,
      id:'',
      search:{
        keyword: '',
        time: '',
        page:1,
        limit:10,
        total:0,
      },
      tableData:[]
    }
  },
  components: {addXuanchuanDialog},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 5
    })
    this.list()
  },
  methods: {
    async list() {
      let _data = await promote_lst(
        this.search.keyword,
        this.search.time ? this.search.time.join(',') : '',
        this.search.page,
        this.search.limit
      );
      if (_data.status == 200) {
        this.tableData = _data.data.data;
        this.search.total = _data.data.total;
      }
    },

    add(){
      this.id = ''
      this.dialogVisible = true
    },

    edit(row){
      this.id = row.id
      this.dialogVisible = true
    },

    del(row){
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let _data = await del_promote(row.id);
        if (_data.status == 200) {
          this.$message({
            type: 'success',
            message: _data.msg
          });
          this.list()
        }
      })
    },

    searchFun() {
      this.search.page = 1
      this.tableData = []
      this.list()
    },

    reset() {
      this.search.keyword = ''
      this.search.time = ''
      this.searchFun()
    },

    handleClose(){
      this.dialogVisible = false
      this.id = ''
      this.searchFun()
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  .edit {
    display: inline-block;
    margin: 0 15px;
    color: #0089ff;
    cursor: pointer;
  }
  .del {
    display: inline-block;
    margin: 0 15px;
    color: #f74945;
    cursor: pointer;
  }
  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 2px solid #e3e7f0;
      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }
      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px
        rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    .list {
      width: 100%;
      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;
        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }
        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }
        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }
        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }
    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;
      .shensu {
        width: 153px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;
          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }
          &.reset {
            background-image:none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;
            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


